  @if (icon().generalIcon) {
    <app-icon class="icon" [svgIcon]="icon().generalIcon"
              [matTooltip]="icon().tooltip" [style.color]="icon().color ? 'var('+icon().color+')' : null"></app-icon>
  } @else if (icon().vendorName) {
    <app-vendor-icon class="icon vendor" [vendorName]="icon().vendorName"
                     [matTooltip]="icon().vendorName"></app-vendor-icon>
  } @else if (icon().assetType) {
    <app-icon class="icon" [svgIcon]="iconsAssetsByType[icon()?.assetType]"
              [matTooltip]="assetTypeTooltip(icon()?.assetType)"></app-icon>
  }
